import { render, staticRenderFns } from "./Step6Income.vue?vue&type=template&id=1182b704"
import script from "./Step6Income.vue?vue&type=script&lang=js"
export * from "./Step6Income.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports